var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",attrs:{"id":"time-range-container"}},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v("Time is: "+_vm._s(_vm._f("formatTime")(_vm.time)))]),_c('div',{attrs:{"id":"time-range-slider"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }